const initIntlTelInput = () => {
  const phoneInput = $(".intlTelInput");

  phoneInput.intlTelInput({
    initialCountry: "FR",
    preferredCountries: ["FR"],
    separateDialCode: true,
    formatOnDisplay: true,
    autoHideDialCode: false,
    nationalMode: false,
    hiddenInput: "full",
    utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@22.0.2/build/js/utils.js",
  });

  phoneInput.closest("form").on("submit", (e) => {
    phoneInput.val(phoneInput.intlTelInput("getNumber"));
  })
}

$(document).ready(initIntlTelInput);
